import "./SearchTrendingTag.scss";

interface ITrendingTagsProps {
  title: string;
  onClick: (value: string) => void;
}

export const SearchTrendingTag = ({ title, onClick }: ITrendingTagsProps) => {
  const handleClick = () => {
    onClick(title);
  };

  return (
    <div className="TrendingTag" onClick={handleClick}>
      <div className="TrendingTag-Circle" />
      <span>{ title }</span>
    </div>
  );
};
